import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { AuthenticationService } from '../../_services/authentication.service'
import { RequestsService } from 'src/app/_shared/services/requests.service'

@Component({
  selector: 'app-add-crop-modal',
  templateUrl: './add-crop-modal.component.html',
  styleUrls: ['./add-crop-modal.component.scss'],
})
export class AddCropModalComponent implements OnInit {
  @Input() addCrop
  @Output() successAddCropEvent = new EventEmitter()
  @Output() successMessage = new EventEmitter()

  success = false
  loading = false
  db_errors: string = null
  errors: string
  country_id: string
  countryName: string
  file: any = null
  model: any = {}

  requiredField: any = {
    crop: false,
    photo: false,
  }

  constructor(
    private RequestService: RequestsService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() { 
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country_id, country } = currentUser
    this.country_id = country_id
    this.countryName = country
  }

  createCrop(createCropForm) {
    this.loading = true
    let formData = new FormData()
    if (this.file) {
      formData.append('photo', this.file, this.file.name)
    }
    formData.append('crop', createCropForm.crops)
    this.RequestService.dash_putWithImage(
      `enterprises/${this.countryName}`,
      formData
    ).subscribe(
      (response) => {
        this.loading = false
        if (response.success == true) {
          this.success = true
          this.refreshAddCrop()
          this.successMessage.emit(response.message)
        } else {
          this.success = false
          // this.refreshAddCrop();
          this.successMessage.emit(response.message)
        }
      },
      (error) => this.handlerError(error)
    )
  }

  processImage(event) {
    const {
      target: { files },
    } = event
    if (
      files.length > 0 &&
      /\.(jpg|jpeg|png)$/i.test(files[0].name) &&
      files[0].size < 2000000
    ) {
      this.file = event.target.files[0]
    } else {
      this.requiredField.photo = true
    }
  }

  refreshAddCrop() {
    this.successAddCropEvent.emit()
  }

  handlerError(error) {
    this.loading = false
    this.db_errors = error.error.error
  }
}
